import { clearLocalStoragePreservingBrand } from "./localStorageBrand";

let isRedirecting = false;

export function isAuthExpiredResponse(status, body) {
  if (Number(status) !== 401) return false;
  const message = String(body?.message || "");
  const code = body?.code;
  return (
    message.includes("expired") ||
    message.includes("Token has expired") ||
    message.includes("Token expired") ||
    message.includes("Token is not valid") ||
    code === 401
  );
}

/** Same logout path as the axios interceptor, for fetch() callers. */
export function redirectToLoginIfSessionExpired(status, body) {
  if (!isAuthExpiredResponse(status, body)) return false;
  if (typeof window === "undefined") return true;
  if (isRedirecting || window.location.pathname === "/login") return true;
  isRedirecting = true;
  console.warn("🔒 Token expired - forcing logout and redirecting to login");
  clearLocalStoragePreservingBrand();
  sessionStorage.clear();
  window.location.href = "/login?expired=1";
  return true;
}
